import { Skeleton } from '@/components/atoms';
import { useUIColors } from '@/core/hooks';
import React from 'react';
import { StyleSheet, View } from 'react-native';
import { GUEST_CARD_MAX_WIDTH } from '../../constants/guestLayout';

export interface GuestPropertyCardSkeletonProps {
  /**
   * Same as GuestPropertyCard.fullWidth — fill parent (details explore sidebar)
   * instead of capping at the listing-grid max width.
   */
  readonly fullWidth?: boolean;
}

/** Mirrors GuestPropertyCard box model (Figma guest list / explore cards). */
export function GuestPropertyCardSkeleton({
  fullWidth = false,
}: Readonly<GuestPropertyCardSkeletonProps>) {
  const colors = useUIColors();

  return (
    <View
      style={[
        styles.container,
        fullWidth ? styles.containerFullWidth : null,
        { backgroundColor: colors.backgroundLevel1 },
      ]}
    >
      <View style={styles.imageWrap}>
        <Skeleton width="100%" height={230} borderRadius={8} />
      </View>
      <View style={styles.content}>
        <View style={styles.textGroup}>
          <Skeleton width="55%" height={22} borderRadius={4} />
          <Skeleton width="90%" height={16} borderRadius={4} />
        </View>
        <View style={styles.tagsRow}>
          <Skeleton width={92} height={29} borderRadius={4} />
          <Skeleton width={92} height={29} borderRadius={4} />
          <Skeleton width={92} height={29} borderRadius={4} />
          <Skeleton width={92} height={29} borderRadius={4} />
        </View>
      </View>
    </View>
  );
}

const styles = StyleSheet.create({
  /** Mirrors GuestPropertyCard: max 443, minHeight 344, radius 12, gap 16, padding 8. */
  container: {
    borderRadius: 12,
    borderWidth: 0,
    overflow: 'hidden',
    width: '100%',
    maxWidth: GUEST_CARD_MAX_WIDTH,
    minWidth: 0,
    minHeight: 344,
    flexDirection: 'column',
    gap: 16,
    padding: 8,
    flex: 1,
  },
  /** Details explore sidebar — match GuestPropertyCard fullWidth. */
  containerFullWidth: {
    maxWidth: '100%',
  },
  imageWrap: {
    width: '100%',
    maxWidth: '100%',
    height: 230,
    borderRadius: 8,
    overflow: 'hidden',
  },
  content: {
    flex: 1,
    width: '100%',
    minWidth: 0,
    gap: 12,
    justifyContent: 'space-between',
  },
  textGroup: {
    gap: 6,
    width: '100%',
    minWidth: 0,
  },
  tagsRow: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    gap: 8,
    width: '100%',
  },
});
